<template>
  <rui-button type="submit" variant="recording" :waiting="loading">
    <template #left>
      <rui-icon :name="loading ? 'rui:hourglass' : defaultIcon" :spin="loading" />
    </template>
    {{ caption || $t('rui.generic.save') }}
  </rui-button>
</template>

<script>
import RuiIcon from '../../Icon/Icon.vue'
import RuiButton from '../../Button/Button.vue'

/**
 * Submit button with an icon and loading state.
 *
 * @propsGroup State   [loading]
 * @propsGroup Content [caption, icon]
 */
export default {
  name: 'RuiSubmitButton',
  components: { RuiButton, RuiIcon },
  props: {
    /** Loading state */
    loading: { required: false, type: Boolean, default: false },
    /** Custom button text */
    caption: { required: false, type: String, default: null },
    /** Custom button icon */
    icon: { required: false, type: String, default: null },
  },
  computed: {
    defaultIcon () {
      return this.icon || 'rui:floppy-disk'
    },
  },
}
</script>
